import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app-store.png'
import _imports_1 from '@/assets/google-play.png'


const _withScopeId = n => (_pushScopeId("data-v-3b410821"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container footer__container" }
const _hoisted_2 = { class: "footer__contacts" }
const _hoisted_3 = { class: "footer__links" }
const _hoisted_4 = { class: "footer__link" }
const _hoisted_5 = {
  key: 0,
  class: "footer__divider"
}
const _hoisted_6 = { class: "footer__copyright" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"footer__apps\" data-v-3b410821><a class=\"footer__app\" href=\"https://apps.apple.com/us/app/lily-plant-identification/id1570145257\" target=\"_blank\" rel=\"noopener\" data-v-3b410821><img src=\"" + _imports_0 + "\" width=\"109\" height=\"38\" alt=\"app store\" data-v-3b410821></a><a class=\"footer__app\" href=\"https://play.google.com/store/apps/details?id=com.laraun.plantapp&amp;hl=uk&amp;gl=US\" target=\"_blank\" rel=\"noopener\" data-v-3b410821><img src=\"" + _imports_1 + "\" width=\"109\" height=\"38\" alt=\"google play\" data-v-3b410821></a></div>", 1)

import { computed } from 'vue';
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';

interface ILink {
  routeName: string;
  title: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultFooter',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

const isFixedPlanVisible = computed<boolean>(
  () => store.state.pricing.isFixedPlanVisible
);

const isTimerVisible = computed<boolean>(
  () => store.state.pricing.isTimerVisible
);

const navLinks: ILink[] = [
  {
    routeName: 'PrivacyPolicyWeb',
    title: t('component_the_menu_privacy_policy'),
  },
  {
    routeName: 'TermsOfUseWeb',
    title: t('component_the_menu_terms_of_use'),
  },
  {
    routeName: 'RefundPolicy',
    title: t('component_the_menu_refund_policy'),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footer", {
      'footer__bottom-padding': _unref(isFixedPlanVisible) && !_unref(isTimerVisible),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('component_the_footer_contacts')), 1),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: link.routeName },
                class: "footer__anchor",
                target: "_blank",
                rel: "noopener"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.title), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            (i !== navLinks.length - 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5))
              : _createCommentVNode("", true)
          ], 64))
        }), 64))
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('component_the_footer_copyright')), 1),
      _hoisted_7
    ])
  ], 2))
}
}

})